import Swiper, { Pagination, Navigation } from 'swiper/core';

// configure Swiper to use modules
Swiper.use([Pagination, Navigation]);
export default function () {

	const sliders = document.querySelectorAll('.default-slider');
	sliders.forEach(slider => {
		var defaultSlider = new Swiper(slider, {
			direction: 'horizontal',
			loop: false,
			slidesPerView: 'auto',

			// If we need pagination
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},

			// Navigation arrows
			navigation: {
				nextEl: '.swiper-nav-next',
				prevEl: '.swiper-nav-prev',
			},

			// And if we need scrollbar
			scrollbar: {
				el: '.swiper-scrollbar',
			},
			on: {
				init: function() {
					this.$el.parent().addClass('slider-container');
				}
			}
		});

	});

	const sliderWithBackground = document.querySelectorAll('.slider-with-background');

	sliderWithBackground.forEach(slider => {
		var bgSlider = new Swiper('.slider-with-background.swiper-container', {
			direction: 'horizontal',
			loop: false,
			slidesPerView: 1,

			// If we need pagination
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},

			// Navigation arrows
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
				clickable: true,
			},

			// And if we need scrollbar
			scrollbar: {
				el: '.swiper-scrollbar',
			},
			on: {
				init: function() {
					this.$el.parent().addClass('slider-container');
				}
			}
		});

	});

}